export const SAVE = 'MedicalExpensesTugoStep.SAVE';
export const VALUE_CHANGED = 'MedicalExpensesTugoStep.VALUE_CHANGED';
export const LOAD = 'MedicalExpensesTugoStep.VALUE_LOAD';
export const NEXT = 'MedicalExpensesTugoStep.NEXT';
export const RESET = 'MedicalExpensesTugoStep.RESET';

export const RESET_FORM_STATE = 'MedicalExpensesTugoStep.RESET_FORM_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.MedicalExpenses/constants.js